import classNames from "classnames";
const Spinner = ({
  width = "w-4",
  height = "h-4",
  colorBorder = "border-gray-300 border-t-gray-700",
}) => {
  return (
    <div
      className={classNames(
        width,
        height,
        colorBorder,
        " border-2 border-t-2  rounded-full animate-spin"
      )}
    ></div>
  );
};

export default Spinner;
